"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_ses_1 = require("@aws-sdk/client-ses");
class SES {
    constructor(toUser, messageSubject, messageBody, fromUser = 'no-reply@br.io') {
        this.toUser = toUser;
        this.fromUser = fromUser;
        this.messageSubject = messageSubject;
        this.messageBody = messageBody;
    }
    getEmailCommand() {
        return new client_ses_1.SendEmailCommand({
            Destination: {
                ToAddresses: [this.toUser]
            },
            Message: {
                Body: {
                    Html: {
                        Charset: 'UTF-8',
                        Data: this.messageBody
                    }
                },
                Subject: {
                    Charset: 'UTF-8',
                    Data: this.messageSubject
                }
            },
            Source: `${this.fromUser}`
        });
    }
    async sendEmail() {
        try {
            const sesClient = new client_ses_1.SESClient({ region: 'us-west-2' });
            const data = await sesClient.send(this.getEmailCommand());
            console.log(`Email sent successfully to ${this.toUser}, data: ${data}`);
        }
        catch (error) {
            console.error('Error sending email:', error);
        }
    }
}
exports.default = SES;
